import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'ebb-portal-program-rules-acknowledge',
  templateUrl: './program-rules-acknowledge.component.html'
})
export class ProgramRulesAcknowledgeComponent implements OnInit {
  @Output() emitProgramRulesAcknowledge = new EventEmitter<boolean>();

  @Input() 
  set programType(programType: any) {
    if (programType === 700000000){ //CEA BB
      this.programRulesLink = '/What-is-CEABB/Program-Rules';
      this.programRulesLinkText = 'CEA BB Program Rules';
    } else {
      if (programType === 700000003) { //ESS
        this.programRulesLink = '/What-is-ESS/Program-Rules';
        this.programRulesLinkText = 'Program Rules';
      } else {
        this.programRulesLink = '/What-is-EBB/Program-Rules';
        this.programRulesLinkText = 'EBB Program Rules';
      }
    }
  }

  public formPermissions: FormGroup;
  public displayTerms: boolean;
  public disableSave = true;
  public programRulesLink:string;
  public programRulesLinkText:string;

  constructor(
    private readonly fb: FormBuilder  
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formPermissions = this.fb.group({
      confirmReviewedTerms: ''
    });
  }
  
  public onChangeEventTerms(event): void {
    this.disableSave = !event.checked;
  }

  public onClickYes(): void {
    this.emitProgramRulesAcknowledge.emit(true);
  }
}
